import Layout from "../components/Layout"
import Helmet from "react-helmet"
import { navigate, withPrefix } from "gatsby"
import React from "react"
import { Lines } from "../components/atoms/Spinners"
import { Router } from "@reach/router"
import { updateCTFTemplate } from "../components/template/updateCTFTemplate"
import { useLiveTemplateData } from "../components/hooks/useLiveTemplateData"

const Rater = props => {
  const { data, error } = useLiveTemplateData(props.contentfulId)
  const LinkResolver = require("../utils/linkResolver")

  if (data && parseInt(props.rating)) {
    const ratedLink = LinkResolver("ContentfulTemplate", data.fields.slug)

    updateCTFTemplate({
      contentfulId: props.contentfulId,
      rating: parseInt(props.rating),
    }).finally(() => {
      if (typeof window !== `undefined`) navigate(`${ratedLink}#rated`)
    })
  }

  if (error && typeof window !== `undefined`) {
    navigate("/")
  }

  return <Lines />
}

const Navigate = () => {
  if (typeof window !== `undefined`) navigate("/")
  return null
}

const TemplateRatePage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Submitting</title>
      </Helmet>
      <div
        style={{
          display: `flex`,
          justifyContent: `center`,
        }}
      >
        <Router basepath={withPrefix("/rate")}>
          <Rater path="/:contentfulId/:rating" />
          {/*@ts-ignore*/}
          <Navigate default />
        </Router>
      </div>
    </Layout>
  )
}

export default TemplateRatePage
